import { Record, List } from 'immutable';

import TOC from './TOC';
import Facilities from './Facilities';
import { resolve } from '../helpers/LinkMapper';


var ServiceDetails = new Record({
    id: null,
    mode: null,
    toc: null,
    reservable: null,
    facilities: new Facilities(),
    isTemporaryTrain: false,
    isCountedPlace: false,
    retailServiceId: null,
    trainUid: null,
    trainRid: null,
    trainOrigin: null,
    trainDestination: null,
});

ServiceDetails.prototype.getFacilities = function () {
    return this.facilities.reduce((a, v, k) => v ? a.push(k) : a, new List());
};

ServiceDetails.fromJSON = function (json) {
    json = json || {};

    const id = resolve(json.id).with(Number);
    const mode = resolve(json.mode).with(String);
    const toc = resolve(json.toc).as(TOC);
    const reservable = resolve(json.reservable).with(String);
    const isTemporaryTrain = resolve(json.isTemporaryTrain).with(Boolean);
    const isCountedPlace = resolve(json.isCountedPlace).with(Boolean);

    const facilities = resolve(json.facilities).as(Facilities) || new Facilities();
    const retailServiceId = json.retailServiceId;
    const trainUid = json.trainUid;
    const trainRid = json.trainRid;
    const trainOrigin = json.trainOrigin;
    const trainDestination = json.trainDestination;

    const result = {
        id,
        mode,
        toc,
        reservable,
        facilities,
        isTemporaryTrain,
        isCountedPlace,
        retailServiceId,
        trainUid,
        trainRid,
        trainOrigin,
        trainDestination,
    };

    return new ServiceDetails(result);
};

export default ServiceDetails;
